import { Link } from "react-router-dom";
import { Sparkles, ArrowLeft } from "lucide-react";

export default function ComingSoon({ title = "In arrivo" }) {
  return (
    <div className="min-h-[60vh] flex flex-col items-center justify-center text-center px-6">
      <Sparkles size={36} className="text-brand mb-4" />
      <h1 className="font-serif text-3xl font-semibold text-onSurface">{title}</h1>
      <p className="text-subtle mt-2 max-w-sm">Questa sezione arriva nella prossima release di Readoo. Stiamo lavorando alla gamification completa.</p>
      <Link to="/" className="mt-6 inline-flex items-center gap-2 px-5 py-3 rounded-full bg-brand text-onBrand text-sm font-semibold hover:bg-brandSecondary transition-colors">
        <ArrowLeft size={16} /> Torna alla home
      </Link>
    </div>
  );
}

export function NotFound() {
  return (
    <div className="min-h-[60vh] flex flex-col items-center justify-center text-center px-6">
      <p className="font-serif text-6xl font-bold text-brand">404</p>
      <h1 className="font-serif text-2xl font-semibold text-onSurface mt-2">Pagina non trovata</h1>
      <Link to="/" className="mt-6 inline-flex items-center gap-2 px-5 py-3 rounded-full bg-brand text-onBrand text-sm font-semibold hover:bg-brandSecondary transition-colors">
        <ArrowLeft size={16} /> Torna alla home
      </Link>
    </div>
  );
}
